import { useIntl } from "react-intl";
import languageTranslator from "./languageTranslator";

const T = (key) => {
    const intl = useIntl();
    return languageTranslator({ intl: intl, key: key })
};

export default T;